<template lang="pug">
	.element-events-add-action(v-show="showed" :style="position" v-pseudo-modal-name="'element-events-add-action'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="addEventAction($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import { ScreenService } from './../../services/Screen'
	import { Emitter } from './../../services/Emitter'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'EditorElementInfoEventsAddAction',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Element Switched",
				"Selected Element Event Added",
				"Selected Element Event Removed"
			],
			events: {
				"Show EditorElementInfoEventsAddAction": function(el, element, event) {

					this.element = element;
					this.event = event;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

					this.update();

				},
				// Клик в любом месте кроме контента помеченного element-events-add-action - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'element-events-add-action') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {

			this.currentElementAnimationItems = [];
			this.currentElementSetPropertyItems = [];
			this.currentElementActionItems = [];
			this.currentElementEventItems = [];
			this.anotherElementItems = [];
			this.screenItems = [];

			return {
				eventItemsTree: [],
				position: {
					right: 0,
					bottom: 0
				}
			};

		},
		methods: {
			collectData() {

				this.mraidSDK = {title: "MraidSDK", opened: false, width: 200, childs: _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'mraid-sdk'), 'priority'), eventAction => {
					return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename}};
				})};

				let webActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'web'), 'priority'), eventAction => {
					return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename, value: eventAction.options?.controlOptions?.default || ''}};
				});

				this.web = webActions.length > 0 ? {title: "Web", opened: false, width: 200, childs: webActions} : null;

				this.currentElement = {title: "Current element", opened: false, childs: [
					{title: "Animations", opened: false, childs: this.currentElementAnimationItems},
					{title: "Properties", opened: false, childs: this.currentElementSetPropertyItems},
					{title: "Actions", opened: false, width: 200, childs: this.currentElementActionItems},
					{title: "Events", opened: false, width: 200, childs: this.currentElementEventItems}
				]};

				this.anotherElements = {title: "Another element", width: 200, opened: false, childs: this.anotherElementItems};

				this.elements = {title: "Elements", width: 200, opened: false, childs: this.anotherElementItems};

				this.scene = {title: "Scene", width: 200, opened: false, childs: this.screenItems};

				this.sceneActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'screen'), 'priority'), eventAction => {
					return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename}};
				});

				this.animationActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'element-animation'), 'priority'), eventAction => {
					return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename}};
				});

				this.propertyActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'element-property'), 'priority'), eventAction => {
					return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename}};
				});

				this.eventItemsTree = [];
				this.currentElementAnimationItems.length = 0;
				this.currentElementSetPropertyItems.length = 0;
				this.currentElementActionItems.length = 0;
				this.currentElementEventItems.length = 0;

				let screens = ScreenService.getVersionScreens(Version.SelectedVersion);

				if (this.element && this.element.type !== 'root-container') {

					let currentElementAnimations = AnimationService.getAnimations(Version.SelectedVersion.id, this.element['screen_codename'], this.element.codename);

					_.each(currentElementAnimations, animation => {

						// Здесь нужно всё сохранять через codename так как эти данные могут быть сохранены в виде шаблона и нельзя ссылаться на конкретные id сущностей
						this.currentElementAnimationItems.push({title: animation.title, opened: false, data: {screenCodename: this.element['screen_codename'], elementCodename: this.element.codename, animationCodename: animation.codename}, width: 200, childs: [...this.animationActions]});

					});

					let currentElementEmitters = Emitter.getEmitters(Version.SelectedVersion.id, this.element['screen_codename'], this.element.codename);

					_.each(currentElementEmitters, emitter => {

						// Здесь нужно всё сохранять через codename так как эти данные могут быть сохранены в виде шаблона и нельзя ссылаться на конкретные id сущностей
						this.currentElementAnimationItems.push({title: emitter.title, opened: false, data: {screenCodename: this.element['screen_codename'], elementCodename: this.element.codename, emitterCodename: emitter.codename}, width: 200, childs: [...this.animationActions]});

					});

					let currentElementProperties = Metadata.ElementPropertiesByCodename;

					_.each(currentElementProperties, property => {

						if (property.options.elementTypes && !_.includes(property.options.elementTypes, this.element.type)) return;

						// Здесь нужно всё сохранять через codename так как эти данные могут быть сохранены в виде шаблона и нельзя ссылаться на конкретные id сущностей
						this.currentElementSetPropertyItems.push({title: property.title, disabled: !property.active, opened: false, data: {screenCodename: this.element['screen_codename'], elementCodename: this.element.codename, elementPropertyCodename: property.codename, elementPropertyValue: property.default}, width: 200, childs: [...this.propertyActions]});

					});

					let currentElementActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'element-actions' && (!eventAction.options.elementTypes || eventAction.options.elementTypes.includes(this.element.type))), 'priority'), eventAction => {
						return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename, screenCodename: this.element['screen_codename'], elementCodename: this.element.codename}};
					});

					this.currentElementActionItems.push(...currentElementActions);

					let currentElementEvents = _.map(Events.getEvents(Version.SelectedVersion.id, this.element['screen_codename'], this.element.codename), event => {

						let eventActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'event' && (!eventAction.options.elementTypes || eventAction.options.elementTypes.includes(this.element.type))), 'priority'), eventAction => {
							return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename, eventCodename: event.codename, screenCodename: this.element['screen_codename'], elementCodename: this.element.codename}};
						});

						return {..._.pick(event, ['title', 'description', 'icon']), width: 200, childs: eventActions};

					});

					this.currentElementEventItems.push(...currentElementEvents);

					this.eventItemsTree.push(..._.compact([this.mraidSDK, this.web, this.currentElement, this.anotherElements, this.scene]));

				} else {

					this.eventItemsTree.push(..._.compact([this.mraidSDK, this.web, this.elements, this.scene]));

				}

				this.anotherElementItems.length = 0;
				this.screenItems.length = 0;

				_.each(screens, screen => {

					this.screenItems.push({title: `Scene: ${screen.title || screen.codename}`, opened: false, width: 200, data: {screenCodename: screen.codename}, childs: [...this.sceneActions]});

					let anotherElementActions = {title: `Scene: ${screen.title || screen.codename}`, opened: false, data: {screenCodename: screen.codename}, childs: []},
						elements = Elements.getVersionElementsTreeList(Version.SelectedVersion, screen.codename, {});

					_.each(elements, element => {

						if (element.type === "root-container") return;

						let anotherElementAnimations = [],
							animations = AnimationService.getAnimations(Version.SelectedVersion.id, screen.codename, element.codename);

						_.each(animations, animation => {

							// Здесь нужно всё сохранять через codename так как эти данные могут быть сохранены в виде шаблона и нельзя ссылаться на конкретные id сущностей
							anotherElementAnimations.push({title: animation.title, opened: false, data: {screenCodename: element['screen_codename'], elementCodename: element.codename, animationCodename: animation.codename}, width: 200, childs: [...this.animationActions]});

						});

						let emitters = Emitter.getEmitters(Version.SelectedVersion.id, screen.codename, element.codename);

						_.each(emitters, emitter => {

							// Здесь нужно всё сохранять через codename так как эти данные могут быть сохранены в виде шаблона и нельзя ссылаться на конкретные id сущностей
							anotherElementAnimations.push({title: emitter.title, opened: false, data: {screenCodename: element['screen_codename'], elementCodename: element.codename, emitterCodename: emitter.codename}, width: 200, childs: [...this.animationActions]});

						});

						let anotherElementProperties = [],
							properties = Metadata.ElementPropertiesByCodename;

						_.each(properties, property => {

							if (property.options.elementTypes && !_.includes(property.options.elementTypes, element.type)) return;

							// Здесь нужно всё сохранять через codename так как эти данные могут быть сохранены в виде шаблона и нельзя ссылаться на конкретные id сущностей
							anotherElementProperties.push({title: property.title, disabled: !property.active, opened: false, data: {screenCodename: element['screen_codename'], elementCodename: element.codename, elementPropertyCodename: property.codename, elementPropertyValue: property.default}, width: 200, childs: [...this.propertyActions]});

						});

						let anotherElementElementActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'element-actions' && (!eventAction.options.elementTypes || eventAction.options.elementTypes.includes(element.type))), 'priority'), eventAction => {
							return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename, screenCodename: element['screen_codename'], elementCodename: element.codename}};
						});

						let anotherElementEventItems = _.map(Events.getEvents(Version.SelectedVersion.id, element['screen_codename'], element.codename), event => {

							let eventActions = _.map(_.orderBy(_.filter(Metadata.EventActionsByCodename, eventAction => eventAction.type === 'event' && (!eventAction.options.elementTypes || eventAction.options.elementTypes.includes(element.type))), 'priority'), eventAction => {
								return {..._.pick(eventAction, ['title', 'description', 'icon']), disabled: !eventAction.active, data: {eventActionCodename: eventAction.codename, eventCodename: event.codename, screenCodename: element['screen_codename'], elementCodename: element.codename}};
							});

							return {..._.pick(event, ['title', 'description', 'icon']), width: 200, childs: eventActions};

						});

						anotherElementActions.childs.push({title: element.codename, opened: false, childs: [
							{title: "Animations", opened: false, childs: anotherElementAnimations},
							{title: "Properties", opened: false, childs: anotherElementProperties},
							{title: "Actions", opened: false, width: 200, childs: anotherElementElementActions},
							{title: "Events", opened: false, width: 200, childs: anotherElementEventItems}
						]});

					});

					this.anotherElementItems.push(anotherElementActions);

				});

				// Если всего один экран у креатива
				if (_.size(screens) === 1) {

					// Сделаем скрытым единственный выбор экрана чтобы уменьшить количество действий пользователя
					if (this.anotherElements.childs[0]) this.anotherElements.childs[0].hidden = true;
					if (this.elements.childs[0]) this.elements.childs[0].hidden = true;
					if (this.scene.childs[0]) this.scene.childs[0].hidden = true;

				}

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(this.eventItemsTree);

				//console.log('eventItemsTree', this.$refs.dropdownMenu, this.eventItemsTree);

			},
			addEventAction(item, data) {

				Server.sendToSocket({
					AddEventAction: {
						eventId: this.event.id,
						eventActionCodename: data.eventActionCodename,
						data: _.omit(data, ['eventActionCodename'])
					}
				});

				this.close();

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.element-events-add-action
		position: absolute
		user-select: none

</style>
